import React from 'react';

// Column/gap presets; each sets the CSS vars read by the shared .card-grid rule in index.css.
export const GRID_LAYOUTS = {
  '2-4': '[--cg-gap:1rem] [--cg-cols:2] md:[--cg-cols:4]',
  '1-2-4': '[--cg-gap:1.5rem] [--cg-cols:1] sm:[--cg-cols:2] lg:[--cg-cols:4]',
  '1-2-3': '[--cg-gap:1.5rem] [--cg-cols:1] sm:[--cg-cols:2] lg:[--cg-cols:3]',
  '1-3': '[--cg-gap:1.5rem] [--cg-cols:1] md:[--cg-cols:3]',
  '1-md2': '[--cg-gap:1.25rem] lg:[--cg-gap:1.5rem] [--cg-cols:1] md:[--cg-cols:2]',
  'phones': '[--cg-gap:2rem] sm:[--cg-gap:1.5rem] [--cg-cols:1] sm:[--cg-cols:3]',
};

export const CardGrid = ({ layout, testId, className = '', children }) => (
  <div data-testid={testId} data-cardgrid="" className={`card-grid ${GRID_LAYOUTS[layout]} ${className}`}>
    {children}
  </div>
);
